import { useLoggedInUser } from 'features/auth/hooks/useAuthData';
import { useCallback } from 'react';
import { PendoEventType, PendoInitOptions, PendoTrackEventPayload } from '../types';
import { initializePendo, trackEvent as trackPendoEvent } from '../utils/pendoUtils';

export const usePendo = () => {
  const user = useLoggedInUser();
  const trackEvent = useCallback(
    // Init Options is passed to track properly in case of
    // onboarding when user data is not yet set in Redux through AuthGuard
    async (
      eventName: PendoEventType,
      eventData: PendoTrackEventPayload,
      initOptions?: PendoInitOptions,
    ) => {
      try {
        // Ensure Pendo session is initialized for users
        if (!pendo || ((pendo as any).isAnonymousVisitor && (pendo as any).isAnonymousVisitor())) {
          console.log('Re-initializing Pendo before tracking event');
          const userId = initOptions?.userId || user?.id;
          const hospitalId = initOptions?.hospitalId || user?.hospital.id;
          await initializePendo(userId, hospitalId);
        }

        const trackEventData: Record<string, string> = { ...eventData };

        delete trackEventData.eventType; // Remove redundant eventType from payload
        trackPendoEvent(eventName, trackEventData);
      } catch (error) {
        console.error('Error tracking Pendo event');
      }
    },
    [user],
  );

  return {
    trackEvent,
  };
};
